import { Instagram, Linkedin } from "lucide-react";
import { CAJUSPLogo } from "../components/CAJUSPLogo";
import { NAV_LINKS } from "../data/content";
import { scrollToId } from "../lib/scroll";

export const Footer = () => (
    <footer data-testid="site-footer" className="bg-graphite-deep">
        <div className="mx-auto max-w-7xl px-5 py-16 sm:px-8 sm:py-20">
            <div className="grid gap-12 md:grid-cols-12">
                <div className="md:col-span-5">
                    <CAJUSPLogo variant="light" className="h-24 w-auto" />
                    <p className="mt-6 max-w-sm text-sm leading-relaxed text-graphite-mute">
                        Soluções estruturadas para conflitos que exigem segurança, especialização e
                        confiança. Estrutura, independência e discrição na resolução de conflitos
                        empresariais.
                    </p>
                    <div className="mt-8">
                        <p className="font-mono text-[10px] uppercase tracking-[0.28em] text-graphite-mute">
                            Redes sociais · em breve
                        </p>
                        <div className="mt-3 flex gap-3">
                            <button
                                type="button"
                                data-testid="footer-linkedin-placeholder"
                                title="LinkedIn — em breve"
                                aria-label="LinkedIn da CAJUSP — em breve"
                                className="flex h-10 w-10 cursor-not-allowed items-center justify-center rounded-sm border border-graphite-line text-graphite-mute/60"
                            >
                                <Linkedin size={17} strokeWidth={1.6} />
                            </button>
                            <button
                                type="button"
                                data-testid="footer-instagram-placeholder"
                                title="Instagram — em breve"
                                aria-label="Instagram da CAJUSP — em breve"
                                className="flex h-10 w-10 cursor-not-allowed items-center justify-center rounded-sm border border-graphite-line text-graphite-mute/60"
                            >
                                <Instagram size={17} strokeWidth={1.6} />
                            </button>
                        </div>
                    </div>
                </div>

                <div className="md:col-span-3">
                    <p className="font-mono text-[10px] uppercase tracking-[0.28em] text-gold-light">
                        Navegação
                    </p>
                    <ul className="mt-5 space-y-3">
                        {NAV_LINKS.map((l) => (
                            <li key={l.id}>
                                <a
                                    href={l.href}
                                    data-testid={`footer-nav-${l.id}`}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        scrollToId(l.href);
                                    }}
                                    className="text-sm text-graphite-mute transition-colors hover:text-gold-light"
                                >
                                    {l.label}
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>

                <div className="md:col-span-4">
                    <p className="font-mono text-[10px] uppercase tracking-[0.28em] text-gold-light">
                        A CAJUSP
                    </p>
                    <p className="mt-5 text-sm leading-relaxed text-graphite-mute">
                        Câmara arbitral em São Paulo dedicada à arbitragem para empresas e à
                        mediação de conflitos empresariais: resolução de conflitos contratuais,
                        orientação sobre como resolver conflitos entre sócios e como resolver
                        conflitos empresariais com estrutura, independência e confidencialidade.
                    </p>
                    <p className="mt-6 border-l-2 border-gold/50 pl-4 text-xs leading-relaxed text-graphite-mute/80">
                        Observação jurídica: a confidencialidade deve ser estabelecida e observada
                        conforme a legislação aplicável, os regulamentos institucionais e os
                        compromissos assumidos pelas partes. A arbitragem não é automaticamente
                        sigilosa em todas as situações. Este site tem caráter institucional e
                        informativo e não constitui aconselhamento jurídico.
                    </p>
                </div>
            </div>

            <div className="mt-16 flex flex-col items-start justify-between gap-4 border-t border-graphite-line pt-8 sm:flex-row sm:items-center">
                <p className="font-mono text-[10px] uppercase tracking-[0.24em] text-graphite-mute">
                    © 2026 CAJUSP — Câmara de Juízo Arbitral e Mediação Empresarial de São Paulo
                </p>
                <p className="font-mono text-[10px] uppercase tracking-[0.24em] text-graphite-mute/60">
                    São Paulo · Brasil
                </p>
            </div>
        </div>
    </footer>
);
